export enum CentralPaymentPolicyFormField {
    Name = 'name',
    PaymentPolicyKey = 'key',
    Trigger = 'trigger',
    Offset = 'offset',
    PercentageValue = 'percentageValue',
    Action = 'action',
    Type = 'type',
    OffsetType = 'offsetType',
    Amount = 'amount',
}
